import { render, staticRenderFns } from "./editor_lookchapter.vue?vue&type=template&id=5a6861c1&scoped=true"
import script from "./editor_lookchapter.vue?vue&type=script&lang=js"
export * from "./editor_lookchapter.vue?vue&type=script&lang=js"
import style0 from "./editor_lookchapter.vue?vue&type=style&index=0&id=5a6861c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6861c1",
  null
  
)

export default component.exports